// TODO: FIX TYPES
import { get } from 'lodash';

interface VariantOptions {
    defaultVariant?: string;
    ignoreErrors?: boolean;
}

/**
 * Create variants helper
 * @example
 * const VARIANTS = {
 *     default: ()  => "Hello user!",
 *     user: (data) => `Hello ${ data.name }`
 * };
 *
 * // This type of calling offer IDE syntax support.
 * // Doing `const VARIANTS = buildVariants({ ... })` it will
 * // kill IDE auto complete of variant prop.
 * buildVariants(VARIANTS);
 *
 * interface ComponentProps {
 *     variant: $Keys<typeof VARIANTS>;
 * }
 * const Component = (props: ComponentProps) => {
 *     const variant$ = VARIANTS.getVariant(props.variant);
 * }
 *
 * Component.defaultProps = {
 *     variant: VARIANTS.getDefaultVariant()
 * };
 *
 * @param variants
 * @param options
 */
export const buildVariants = <P extends any = Record<string, any>>(
    variants: P,
    options: VariantOptions = {},
): P & {
    keys(): Omit<keyof P | 'default', 'keys' | 'getVariant' | 'getDefaultVariant'>;
    getVariant<T = any>(name?: Omit<keyof P | 'default', 'keys' | 'getVariant' | 'getDefaultVariant'>): T;
    getDefaultVariant<T = any>(): T;
} => {
    options = {
        defaultVariant: 'default',
        ...(options as any),
    };

    // store variant keys
    // @ts-ignore
    variants.__keys = Object.keys({ ...variants });

    /**
     * Get variant keys
     * @returns {Array<string>}
     */
    // @ts-ignore
    variants.keys = (): string[] => variants.__keys;

    /**
     * Get variant value
     * @param name
     * @returns {*}
     */
    // @ts-ignore
    variants.getVariant = <T = any>(name?: Omit<keyof P | 'default', 'keys' | 'getVariant' | 'getDefaultVariant'>): T =>
        get(variants, (variants as any)._getVariantName(name)) as any;

    /**
     * Get variant name
     * @param name
     * @private
     * @returns {string}
     */
    // @ts-ignore
    variants._getVariantName = (
        name?: Omit<keyof P | 'default', 'keys' | 'getVariant' | 'getDefaultVariant'>,
    ): string => {
        // @ts-ignore
        if (!name || !variants.hasOwnProperty(name)) {
            if (!options.ignoreErrors) {
                // @ts-ignore
                throw new Error(`Variant '${name as any}' doesn't exist on list [${variants.keys().join(', ')}]!`);
            }
            // @ts-ignore
            name = variants.getDefaultVariant();
        }

        return `${name as any}`;
    };

    /**
     * Get default variant name
     * @returns {string}
     */
    // @ts-ignore
    variants.getDefaultVariant = (): any => options.defaultVariant;

    return variants as any;
};
